import type { ContentInsertType } from "../types"

export const DIAGRAM_CONTENT_TYPES = ["geometry", "graph"] as const

export const DIAGRAM_DATA_ATTR = {
  contentType: "data-content-type",
  diagramXml: "data-diagram-xml",
} as const

/** Keeps exported diagrams readable at a consistent size in the editor. */
export const DIAGRAM_LIGHT_CANVAS_STYLE =
  "background-color:#fff;color-scheme:light;"

export const DIAGRAM_DISPLAY_STYLE =
  `display:block;max-width:420px;max-height:320px;width:auto;height:auto;object-fit:contain;${DIAGRAM_LIGHT_CANVAS_STYLE}`

export const DRAWIO_EMBED_URL_PARAMS = {
  ui: "kennedy" as const,
  dark: false,
  spin: true,
  noSaveBtn: true,
  libraries: true,
  saveAndExit: false,
  noExitBtn: true,
  grid: true,
}

/** Minimal export action — extra params (theme, transparent, spin) break xmlsvg in embed. */
export const DRAWIO_EXPORT_OPTIONS = {
  format: "xmlsvg" as const,
}

export const isDiagramContentType = (
  value: string | null | undefined
): value is ContentInsertType =>
  value === "geometry" || value === "graph"

export const diagramAltLabel = (contentType: ContentInsertType): string =>
  contentType === "graph" ? "Graph" : "Geometry diagram"

export const diagramTypeLabel = (contentType: ContentInsertType): string =>
  contentType === "graph" ? "Graph" : "Geometry"
